import { jsx as _jsx } from "react/jsx-runtime";
import { Markdown } from '../../markdown';
export function SchemaDescription({ schema }) {
    if (typeof schema === 'boolean') {
        return null;
    }
    return _jsx(Markdown, { content: schema.description });
}
